import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { useTheme } from '@material-ui/core/styles';

import { converParameters, getHost } from 'lib/commonLib';
import { abusingRateGraph, abusingRateReport } from 'lib/api/abusing';

import MbTooltip from 'components/atoms/MbTooltip';
import MbButton from 'components/atoms/MbButton';
import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import BarGraph from 'components/organisms/Chart/BarGraph';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

const RateStatistics = ({ customized, handlePortalUrl }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
    type: 'rate',
  };
  const [params, setParams] = useState(initParams);
  const [initialization, setInitialization] = useState(false);
  const [adverCnt, setAdverCnt] = useState(0);

  const graphList = [
    {
      title: t('세션전환수'),
      data: { bar: ['SESSION_CONV_CNT'] },
      yAxisData: { left: { SESSION_CONV_CNT: true }, right: {} },
      referenceLine: {
        SESSION_CONV_CNT: {
          type: 'average',
          label: t('세션전환수'),
          visibleValue: true,
          color: theme.palette.common.red,
        },
      },
    },
    {
      title: t('세션전환율'),
      data: { bar: ['SESSION_CONV_RATE'] },
      yAxisData: { left: { SESSION_CONV_RATE: true }, right: {} },
      referenceLine: {
        SESSION_CONV_RATE: {
          type: 'average',
          label: t('세션전환율'),
          visibleValue: true,
          color: theme.palette.common.red,
        },
      },
      customizeData: { SESSION_CONV_RATE: { isPercent: true, tooltipFormat: '0.00' } },
    },
    {
      title: t('광고주 수'),
      data: { bar: ['ADVER_CNT'] },
      yAxisData: { left: { ADVER_CNT: true }, right: {} },
      referenceLine: {
        ADVER_CNT: {
          type: 'average',
          label: t('광고주 수'),
          visibleValue: true,
          color: theme.palette.common.red,
        },
      },
    },
  ];

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
      setAdverCnt(0);
    }
  };

  // 화면에서 추가될 컬럼
  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        const showWindowUrl = converParameters({
          url: getHost() + '/v2/popup/manage_report_media_day_mc_mcode.php',
          mcode: data['ADVER_ID'],
          st_date: moment(params.sDate).format('YYYY-MM-DD'),
          en_date: moment(params.eDate).format('YYYY-MM-DD'),
          gb: 'TOT',
        });
        return (
          data['ADVER_NAME'] !== 'total' && (
            <TableBtnWrap>
              <MbTooltip
                title={t('해당 광고주의 상세 통계')}
                onClick={() => handlePortalUrl(showWindowUrl)}
              >
                <MbButton iconBtn icon="faExternalLink" />
              </MbTooltip>
              <NewButton
                title={t('사이트로 이동')}
                iconBtn
                icon="faHome"
                onClick={() => handlePortalUrl('http://' + data['URL'])}
                disableRipple
              />
            </TableBtnWrap>
          )
        );
      },
    });
    return result;
  })();

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDisplayFilter={false}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
        />
      </NewFilterWrap>
      <BarGraph
        params={{ sDate: params.sDate, eDate: params.eDate }}
        dataReqPromise={abusingRateGraph}
        graphList={graphList}
        title={t('전환율 데이터 그래프')}
        labelType="MMDD"
        subTitle={!!adverCnt ? t('광고주 수') + ': ' + adverCnt : null}
      />
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={abusingRateReport}
        customized={customized}
        toolTip={t('전환률 5% 이상 광고주를 표기 합니다.')}
        useFetch={false}
        addColumnList={addColumnList}
        reFetchHead
        callBack={(type, data) => {
          if (data['ADVER_NAME'] === 'total') {
            setAdverCnt(data['ADVER_ID']);
          }
        }}
        borderRangeStart={9}
        borderRangeEnd={13}
      />
    </>
  );
};

export default RateStatistics;
